<template>
  <div class="d-flex flex-column flex-root">
    <div class="page d-flex flex-row flex-column-fluid">
      <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <div id="kt_header" class="header">
          <div class="container-fluid d-flex align-items-center flex-wrap justify-content-between" id="kt_header_container">
            <div class="page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-2 pb-5 pb-lg-0 pt-7 pt-lg-0">
              <h1 class="d-flex flex-column text-dark fw-bolder my-0">
                Gửi email cho người dùng
                <small class="text-muted fs-6 fw-bold pt-1">Soạn thông báo, chọn người nhận, gửi thử rồi gửi thật</small>
              </h1>
            </div>
            <div class="d-flex d-lg-none align-items-center ms-n3 me-2">
              <div class="btn btn-icon btn-active-icon-primary" id="kt_aside_toggle">
                <span class="svg-icon svg-icon-1 mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z" fill="black"/>
                    <path opacity="0.3" d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z" fill="black"/>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
          <div class="container-fluid" id="kt_content_container">
            <div class="mail-tabs">
              <button :class="{'is-active': tab === 'compose'}" @click="tab = 'compose'">
                <i class="bi bi-pencil-square"></i> Soạn email
              </button>
              <button :class="{'is-active': tab === 'history'}" @click="openHistory()">
                <i class="bi bi-clock-history"></i> Lịch sử gửi
              </button>
            </div>

            <!-- ================= Lịch sử ================= -->
            <div v-if="tab === 'history'" class="hist">
              <div class="hist__bar">
                <span class="text-muted">Tổng {{ $numberFormat(history.metaData?.total || 0) }} lần gửi</span>
                <span v-if="hasRunning" class="hist__live"><span class="hist__dot"></span> Đang gửi – tự cập nhật</span>
                <button class="btn btn-sm btn-light ms-auto" @click="loadHistory()" :disabled="historyLoading">
                  <span v-if="historyLoading" class="spinner-border spinner-border-sm me-1"></span>
                  <i v-else class="bi bi-arrow-clockwise"></i> Làm mới
                </button>
              </div>
              <div v-if="!history.data.length && !historyLoading" class="mail-empty">
                <i class="bi bi-inbox"></i> Chưa gửi email nào
              </div>
              <div v-for="c in history.data" :key="c.id" class="hist-item" @click="openCampaign(c)">
                <div class="hist-item__main">
                  <div class="hist-item__subject">
                    <span v-if="c.test" class="hist-tag hist-tag--test">Gửi thử</span>
                    {{ c.subject }}
                  </div>
                  <div class="hist-item__meta">
                    <span><i class="bi bi-calendar3"></i> {{ $formatDateTime2(c.createdAt) }}</span>
                    <span v-if="c.createdByName || c.createdByEmail"><i class="bi bi-person"></i> {{ c.createdByName || c.createdByEmail }}</span>
                    <span><i class="bi bi-people"></i> {{ targetText(c) }}</span>
                  </div>
                </div>
                <div class="hist-item__stats">
                  <div class="hist-progress" :title="progressTitle(c)">
                    <span class="is-success" :style="{width: pct(c.success, c.total)}"></span>
                    <span class="is-fail" :style="{width: pct(c.fail, c.total)}"></span>
                    <span class="is-pending" :style="{width: pct(c.pending, c.total)}"></span>
                  </div>
                  <div class="hist-nums">
                    <span class="text-success"><b>{{ $numberFormat(c.success || 0) }}</b> thành công</span>
                    <span v-if="c.fail" class="text-danger"><b>{{ $numberFormat(c.fail) }}</b> lỗi</span>
                    <span v-if="c.pending" class="text-warning"><b>{{ $numberFormat(c.pending) }}</b> đang chờ</span>
                    <span class="text-muted">/ {{ $numberFormat(c.total || 0) }}</span>
                  </div>
                  <span class="hist-status" :class="'hist-status--' + statusOf(c).key">{{ statusOf(c).label }}</span>
                </div>
              </div>
              <div class="hist__pager" v-if="(history.metaData?.totalPage || 0) > 1">
                <button class="btn btn-sm btn-light" :disabled="historyPage <= 0" @click="historyPage--; loadHistory()">
                  <i class="bi bi-chevron-left"></i>
                </button>
                <span>Trang {{ historyPage + 1 }} / {{ history.metaData.totalPage }}</span>
                <button class="btn btn-sm btn-light" :disabled="historyPage + 1 >= history.metaData.totalPage"
                        @click="historyPage++; loadHistory()">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>

            <!-- Chi tiết 1 lần gửi -->
            <b-modal v-model="detailOpen" size="lg" hide-footer :title="detail ? ('#' + detail.id + ' · ' + detail.subject) : ''">
              <div v-if="detail">
                <div class="hist-detail__nums">
                  <div><b>{{ $numberFormat(detail.total || 0) }}</b><small>người nhận</small></div>
                  <div class="text-success"><b>{{ $numberFormat(detail.success || 0) }}</b><small>thành công</small></div>
                  <div class="text-danger"><b>{{ $numberFormat(detail.fail || 0) }}</b><small>lỗi</small></div>
                  <div class="text-warning"><b>{{ $numberFormat(detail.pending || 0) }}</b><small>đang chờ</small></div>
                  <div class="text-muted"><b>{{ $numberFormat(detail.skipped || 0) }}</b><small>bỏ qua</small></div>
                </div>
                <div class="hist-detail__info">
                  <div><span>Gửi lúc</span>{{ $formatDateTime2(detail.createdAt) }}</div>
                  <div><span>Người gửi</span>{{ detail.createdByName || detail.createdByEmail || '—' }}</div>
                  <div><span>Đối tượng</span>{{ targetText(detail) }}</div>
                  <div v-if="detail.ctaUrl"><span>Nút</span>{{ detail.ctaText || 'Xem chi tiết' }} → {{ detail.ctaUrl }}</div>
                </div>
                <div class="d-flex gap-2 mb-3">
                  <button v-for="f in recipientFilters" :key="f.value || 'all'" class="btn btn-sm"
                          :class="recipientStatus === f.value ? 'btn-primary' : 'btn-light'"
                          @click="recipientStatus = f.value; recipientPage = 0; loadRecipients()">
                    {{ f.label }}
                  </button>
                  <button class="btn btn-sm btn-light-primary ms-auto" @click="reuse(detail)">
                    <i class="bi bi-files"></i> Dùng lại nội dung
                  </button>
                </div>
                <div class="hist-recipients">
                  <div v-for="r in recipients.data" :key="r.id" class="hist-recipients__row">
                    <span>{{ r.to }}</span>
                    <span class="hist-status" :class="'hist-status--' + (r.sentStatus || '').toLowerCase()">
                      {{ {SUCCESS: 'Thành công', FAIL: 'Lỗi', PENDING: 'Đang chờ'}[r.sentStatus] || r.sentStatus }}
                    </span>
                  </div>
                  <div v-if="!recipients.data.length" class="text-muted text-center py-4">Không có dữ liệu</div>
                </div>
                <div class="hist__pager" v-if="(recipients.metaData?.totalPage || 0) > 1">
                  <button class="btn btn-sm btn-light" :disabled="recipientPage <= 0" @click="recipientPage--; loadRecipients()">
                    <i class="bi bi-chevron-left"></i>
                  </button>
                  <span>Trang {{ recipientPage + 1 }} / {{ recipients.metaData.totalPage }}</span>
                  <button class="btn btn-sm btn-light" :disabled="recipientPage + 1 >= recipients.metaData.totalPage"
                          @click="recipientPage++; loadRecipients()">
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </div>
              </div>
            </b-modal>

            <div v-show="tab === 'compose'" class="mail-page">
              <!-- ============ Cột trái: soạn ============ -->
              <div class="mail-col">
                <section class="mail-card">
                  <h3 class="mail-card__title"><i class="bi bi-pencil-square"></i> Nội dung</h3>

                  <label class="mail-field">
                    <span>Tiêu đề email <b class="text-danger">*</b></span>
                    <input v-model="form.subject" maxlength="200" placeholder="VD: Ưu đãi nạp xu cuối tuần">
                  </label>
                  <label class="mail-field">
                    <span>Tiêu đề lớn trong thư <small>(tuỳ chọn)</small></span>
                    <input v-model="form.title" maxlength="200" placeholder="VD: Tặng thêm 20% xu khi nạp">
                  </label>
                  <label class="mail-field">
                    <span>Nội dung <b class="text-danger">*</b>
                      <small>– text thường (giữ xuống dòng) hoặc HTML</small></span>
                    <textarea v-model="form.content" rows="10"
                              placeholder="Xin chào, chúng tôi xin thông báo…"></textarea>
                  </label>
                  <div class="mail-row">
                    <label class="mail-field">
                      <span>Chữ trên nút <small>(tuỳ chọn)</small></span>
                      <input v-model="form.ctaText" placeholder="Xem chi tiết">
                    </label>
                    <label class="mail-field">
                      <span>Link nút</span>
                      <input v-model="form.ctaUrl" placeholder="https://mottruyen.app/...">
                    </label>
                  </div>
                </section>

                <section class="mail-card">
                  <h3 class="mail-card__title"><i class="bi bi-people"></i> Người nhận</h3>
                  <div class="mail-targets">
                    <label v-for="t in targets" :key="t.value" class="mail-target"
                           :class="{'is-active': form.target === t.value}">
                      <input type="radio" v-model="form.target" :value="t.value">
                      <i class="bi" :class="t.icon"></i>
                      <div>
                        <b>{{ t.label }}</b>
                        <small>{{ t.desc }}</small>
                      </div>
                    </label>
                  </div>

                  <!-- Theo gói -->
                  <div v-if="form.target === 'TYPES'" class="mail-states">
                    <label v-for="s in typeOptions" :key="s.value" class="mail-state"
                           :class="{'is-active': form.types.includes(s.value)}">
                      <input type="checkbox" v-model="form.types" :value="s.value"> {{ s.label }}
                    </label>
                  </div>

                  <!-- Theo trạng thái -->
                  <div v-if="form.target === 'STATES'" class="mail-states">
                    <label v-for="s in stateOptions" :key="s.value" class="mail-state"
                           :class="{'is-active': form.states.includes(s.value)}">
                      <input type="checkbox" v-model="form.states" :value="s.value"> {{ s.label }}
                    </label>
                  </div>

                  <!-- Chọn người dùng -->
                  <div v-if="form.target === 'IDS'" class="mail-pick">
                    <div class="mail-pick__search">
                      <i class="bi bi-search"></i>
                      <input v-model="userKeyword" placeholder="Tìm email, tên hoặc id người dùng…" @input="searchUsersDebounced()">
                      <span v-if="searching" class="spinner-border spinner-border-sm text-primary"></span>
                    </div>
                    <div v-if="userResults.length" class="mail-pick__results">
                      <button v-for="a in userResults" :key="a.id" class="mail-pick__result"
                              :disabled="isPicked(a.id)" @click="pick(a)">
                        <img :src="$getImage(a.avatar)" alt="" @error="$event.target.style.visibility='hidden'">
                        <span class="flex-grow-1 text-start">{{ a.name || 'Không tên' }} <small>#{{ a.id }}</small></span>
                        <small class="text-muted text-truncate">{{ a.email || 'không có email' }}</small>
                        <i class="bi" :class="isPicked(a.id) ? 'bi-check-lg text-success' : 'bi-plus-lg'"></i>
                      </button>
                    </div>
                    <div class="mail-pick__paste">
                      <input v-model="pasteIds" placeholder="Hoặc dán danh sách id, cách nhau bằng dấu phẩy/khoảng trắng">
                      <button class="btn btn-sm btn-light" @click="addPasted()">Thêm</button>
                    </div>
                    <div class="mail-chips">
                      <span v-for="a in picked" :key="a.id" class="mail-chip">
                        {{ a.name || ('#' + a.id) }}
                        <i class="bi bi-x" @click="unpick(a.id)"></i>
                      </span>
                      <span v-if="!picked.length" class="text-muted small">Chưa chọn người dùng nào</span>
                      <button v-if="picked.length" class="btn btn-link btn-sm p-0 ms-auto" @click="picked = []">Bỏ chọn tất cả</button>
                    </div>
                  </div>
                </section>

                <!-- Thanh hành động -->
                <section class="mail-card mail-actions">
                  <div class="mail-test">
                    <input v-model="testEmail" type="email" placeholder="Email nhận thử">
                    <button class="btn btn-light-primary" :disabled="!canSubmit || sending" @click="send(true)">
                      <i class="bi bi-send"></i> Gửi thử
                    </button>
                  </div>
                  <button class="btn btn-primary mail-send" :disabled="!canSubmit || sending || !preview.total" @click="send(false)">
                    <span v-if="sending" class="spinner-border spinner-border-sm me-1"></span>
                    <i v-else class="bi bi-envelope-paper"></i>
                    Gửi cho {{ preview.total != null ? $numberFormat(preview.total) : '…' }} người dùng
                  </button>
                </section>
              </div>

              <!-- ============ Cột phải: xem trước ============ -->
              <div class="mail-col mail-col--preview">
                <section class="mail-card mail-preview">
                  <div class="mail-preview__head">
                    <h3 class="mail-card__title mb-0"><i class="bi bi-eye"></i> Xem trước</h3>
                    <span v-if="previewing" class="spinner-border spinner-border-sm text-primary"></span>
                    <button class="btn btn-sm btn-light ms-auto" :disabled="!canSubmit" @click="loadPreview()">
                      <i class="bi bi-arrow-clockwise"></i> Làm mới
                    </button>
                  </div>
                  <div class="mail-stats">
                    <div><b>{{ preview.total != null ? $numberFormat(preview.total) : '—' }}</b> người nhận</div>
                    <div v-if="preview.skipped"><b>{{ $numberFormat(preview.skipped) }}</b> bỏ qua (không có / trùng email)</div>
                  </div>
                  <div v-if="previewError" class="mail-error">{{ previewError }}</div>
                  <div class="mail-subject" v-if="form.subject"><span>Tiêu đề:</span> {{ form.subject }}</div>
                  <iframe v-if="preview.html" class="mail-frame" :srcdoc="preview.html" sandbox=""></iframe>
                  <div v-else class="mail-empty">
                    <i class="bi bi-envelope"></i>
                    Nhập tiêu đề và nội dung để xem trước
                  </div>
                  <details v-if="preview.sample && preview.sample.length" class="mail-sample">
                    <summary>Người nhận đầu tiên ({{ preview.sample.length }})</summary>
                    <div v-for="r in preview.sample" :key="r.userId" class="mail-sample__row">
                      <span>{{ r.name }} <small>#{{ r.userId }}</small></span>
                      <small>{{ r.email }}</small>
                    </div>
                  </details>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import requestUtil from "@/utils/request-util";
import {BModal} from "bootstrap-vue-3";

const DRAFT_KEY = 'user-email-draft';

export default {
  name: 'UserEmail',
  components: {BModal},
  data() {
    return {
      form: {
        subject: '',
        title: '',
        content: '',
        ctaText: '',
        ctaUrl: '',
        target: 'ALL',
        states: ['ACTIVE'],
        types: ['PREMIUM'],
      },
      picked: [],
      userKeyword: '',
      userResults: [],
      searching: false,
      pasteIds: '',
      testEmail: '',
      preview: {total: null, skipped: 0, html: null, sample: []},
      previewing: false,
      previewError: null,
      sending: false,
      tab: 'compose',
      history: {data: [], metaData: {}},
      historyPage: 0,
      historyLoading: false,
      detailOpen: false,
      detail: null,
      recipients: {data: [], metaData: {}},
      recipientStatus: null,
      recipientPage: 0,
      recipientFilters: [
        {value: null, label: 'Tất cả'},
        {value: 'SUCCESS', label: 'Thành công'},
        {value: 'FAIL', label: 'Lỗi'},
        {value: 'PENDING', label: 'Đang chờ'},
      ],
      targets: [
        {value: 'ALL', label: 'Toàn bộ người dùng', desc: 'Đang hoạt động, có email', icon: 'bi-globe'},
        {value: 'TYPES', label: 'Theo gói', desc: 'Siêu Mọt hoặc Miễn phí', icon: 'bi-gem'},
        {value: 'STATES', label: 'Theo trạng thái', desc: 'Chọn 1 hoặc nhiều trạng thái', icon: 'bi-funnel'},
        {value: 'IDS', label: 'Chọn người dùng', desc: 'Tìm hoặc dán danh sách id', icon: 'bi-person-check'},
      ],
      typeOptions: [
        {value: 'PREMIUM', label: 'Siêu Mọt'},
        {value: 'FREE', label: 'Miễn phí'},
      ],
      stateOptions: [
        {value: 'ACTIVE', label: 'Hoạt động'},
        {value: 'INACTIVE', label: 'Riêng tư'},
        {value: 'LOCKED', label: 'Tạm khoá'},
        {value: 'BLOCK', label: 'Block'},
      ],
    };
  },
  computed: {
    canSubmit() {
      return this.form.subject.trim() && this.form.content.trim();
    },
    body() {
      const f = this.form;
      return {
        subject: f.subject.trim(),
        title: f.title.trim() || null,
        content: f.content,
        ctaText: f.ctaText.trim() || null,
        ctaUrl: f.ctaUrl.trim() || null,
        target: f.target,
        states: f.target === 'STATES' ? f.states : null,
        types: f.target === 'TYPES' ? f.types : null,
        userIds: f.target === 'IDS' ? this.picked.map((a) => a.id) : null,
      };
    },
    hasRunning() {
      return this.history.data.some((c) => c.queued == null || c.pending > 0);
    },
    targetLabel() {
      if (this.form.target === 'ALL') return 'toàn bộ người dùng';
      if (this.form.target === 'TYPES') return 'người dùng gói ' + this.form.types.join(', ');
      if (this.form.target === 'STATES') return 'người dùng có trạng thái ' + this.form.states.join(', ');
      return this.picked.length + ' người dùng đã chọn';
    },
  },
  watch: {
    body: {
      deep: true,
      handler() {
        this.saveDraft();
        clearTimeout(this._previewTimer);
        this._previewTimer = setTimeout(() => this.loadPreview(), 700);
      },
    },
  },
  mounted() {
    this.loadDraft();
    // ?ids=1,2,3 → chọn sẵn người dùng
    const ids = String(this.$route.query.ids || '').split(/[\s,]+/).map(Number).filter((x) => x > 0);
    if (ids.length) {
      this.form.target = 'IDS';
      this.picked = ids.map((id) => ({id}));
      this.hydratePicked();
    }
    this.loadPreview();
  },
  beforeUnmount() {
    clearInterval(this._historyTimer);
    clearTimeout(this._previewTimer);
    clearTimeout(this._searchTimer);
  },
  methods: {
    saveDraft() {
      try {
        localStorage.setItem(DRAFT_KEY, JSON.stringify(this.form));
      } catch (e) { /* bỏ qua */ }
    },
    loadDraft() {
      try {
        const d = JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null');
        if (d) this.form = {...this.form, ...d};
      } catch (e) { /* bỏ qua */ }
    },
    async loadPreview() {
      if (!this.canSubmit) {
        this.preview = {total: null, skipped: 0, html: null, sample: []};
        return;
      }
      if (this.form.target === 'STATES' && !this.form.states.length) {
        this.previewError = 'Chọn ít nhất 1 trạng thái';
        return;
      }
      if (this.form.target === 'TYPES' && !this.form.types.length) {
        this.previewError = 'Chọn ít nhất 1 gói';
        return;
      }
      if (this.form.target === 'IDS' && !this.picked.length) {
        this.previewError = 'Chọn ít nhất 1 người dùng';
        this.preview = {...this.preview, total: 0, sample: []};
        return;
      }
      this.previewing = true;
      this.previewError = null;
      try {
        const res = await requestUtil.post('/admin/user/email/_preview', this.body);
        this.preview = res.data;
      } catch (e) {
        this.previewError = e?.message || 'Không xem trước được';
      } finally {
        this.previewing = false;
      }
    },
    async send(test) {
      if (test) {
        if (!/^\S+@\S+\.\S+$/.test(this.testEmail)) {
          this.$notify({title: 'Nhập email nhận thử hợp lệ', type: 'warn'});
          return;
        }
      } else if (!window.confirm(`Gửi email "${this.form.subject}" cho ${this.preview.total} người dùng (${this.targetLabel})?\nKhông thể thu hồi sau khi gửi.`)) {
        return;
      }
      this.sending = true;
      try {
        const res = await requestUtil.post('/admin/user/email/_send', {
          ...this.body,
          testEmail: test ? this.testEmail.trim() : null,
        });
        this.$notify({
          title: test ? `Đã gửi thử tới ${this.testEmail}` : `Đã xếp hàng ${res.data.total} email`,
          text: test ? 'Email sẽ đến trong khoảng 10–30 giây' : 'Hệ thống gửi dần ~20 email mỗi 10 giây',
          type: 'success',
        });
        if (!test) this.openHistory();
      } catch (e) {
        this.$notify({title: e?.message || 'Gửi thất bại', type: 'error'});
      } finally {
        this.sending = false;
      }
    },
    // ---- lịch sử ----
    openHistory() {
      this.tab = 'history';
      this.historyPage = 0;
      this.loadHistory();
      clearInterval(this._historyTimer);
      // tự làm mới khi còn lần gửi đang chạy
      this._historyTimer = setInterval(() => {
        if (this.tab !== 'history') return clearInterval(this._historyTimer);
        if (this.hasRunning) this.loadHistory(true);
      }, 10000);
    },
    async loadHistory(silent) {
      if (!silent) this.historyLoading = true;
      try {
        const res = await requestUtil.get('/admin/user/email/campaigns', {page: this.historyPage, size: 20});
        this.history = res.data;
        if (this.detailOpen && this.detail) {
          const fresh = this.history.data.find((c) => c.id === this.detail.id);
          if (fresh) this.detail = fresh;
        }
      } catch (e) {
        if (!silent) this.$notify({title: e?.message || 'Không tải được lịch sử', type: 'warn'});
      } finally {
        this.historyLoading = false;
      }
    },
    openCampaign(c) {
      this.detail = c;
      this.detailOpen = true;
      this.recipientStatus = null;
      this.recipientPage = 0;
      this.loadRecipients();
    },
    async loadRecipients() {
      if (!this.detail) return;
      try {
        const res = await requestUtil.get(`/admin/user/email/campaigns/${this.detail.id}/recipients`, {
          status: this.recipientStatus || null, page: this.recipientPage, size: 50,
        });
        this.recipients = res.data;
      } catch (e) {
        this.recipients = {data: [], metaData: {}};
      }
    },
    reuse(c) {
      this.form = {
        ...this.form,
        subject: c.subject || '',
        title: c.title || '',
        content: c.content || '',
        ctaText: c.ctaText || '',
        ctaUrl: c.ctaUrl || '',
      };
      this.detailOpen = false;
      this.tab = 'compose';
      this.$notify({title: 'Đã chép nội dung vào khung soạn', type: 'success'});
    },
    pct(n, total) {
      return total ? Math.min(100, ((n || 0) * 100) / total) + '%' : '0%';
    },
    progressTitle(c) {
      return `Thành công ${c.success || 0} · Lỗi ${c.fail || 0} · Đang chờ ${c.pending || 0} / ${c.total || 0}`;
    },
    statusOf(c) {
      if (c.queued == null) return {key: 'pending', label: 'Đang xếp hàng'};
      if (c.pending > 0) return {key: 'pending', label: 'Đang gửi'};
      if (c.fail > 0) return {key: 'fail', label: 'Hoàn tất (có lỗi)'};
      return {key: 'success', label: 'Hoàn tất'};
    },
    targetText(c) {
      if (c.test) return 'Gửi thử → ' + (c.testEmail || '');
      if (c.target === 'STATES') {
        const map = Object.fromEntries(this.stateOptions.map((s) => [s.value, s.label]));
        return 'Trạng thái: ' + (c.states || []).map((s) => map[s] || s).join(', ');
      }
      if (c.target === 'TYPES') {
        const map = Object.fromEntries(this.typeOptions.map((s) => [s.value, s.label]));
        return 'Gói: ' + (c.types || []).map((s) => map[s] || s).join(', ');
      }
      if (c.target === 'IDS') return (c.userIds || []).length + ' người dùng được chọn';
      return 'Toàn bộ người dùng';
    },
    // ---- chọn người dùng ----
    isPicked(id) {
      return this.picked.some((a) => a.id === id);
    },
    pick(a) {
      if (!this.isPicked(a.id)) this.picked.push({id: a.id, name: a.name || a.email});
    },
    unpick(id) {
      this.picked = this.picked.filter((a) => a.id !== id);
    },
    addPasted() {
      const ids = this.pasteIds.split(/[\s,;]+/).map(Number).filter((x) => Number.isInteger(x) && x > 0);
      ids.forEach((id) => {
        if (!this.isPicked(id)) this.picked.push({id});
      });
      this.pasteIds = '';
      this.hydratePicked();
    },
    /** Lấy tên cho các id dán vào / từ query */
    async hydratePicked() {
      const missing = this.picked.filter((a) => !a.name);
      for (const a of missing) {
        try {
          const res = await requestUtil.get('/admin/user', {keyword: String(a.id), page: 0, size: 5});
          const found = (res.data?.data || []).find((x) => x.id === a.id);
          if (found) a.name = found.name || found.email;
        } catch (e) { /* bỏ qua */ }
      }
    },
    searchUsersDebounced() {
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => this.searchUsers(), 350);
    },
    async searchUsers() {
      const kw = this.userKeyword.trim();
      if (!kw) {
        this.userResults = [];
        return;
      }
      this.searching = true;
      try {
        const res = await requestUtil.get('/admin/user', {keyword: kw, page: 0, size: 8, sort: 'createdAt,desc'});
        this.userResults = res.data?.data || [];
      } finally {
        this.searching = false;
      }
    },
  },
};
</script>

<style scoped>
.mail-page {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
  align-items: start;
  padding-bottom: 24px;
}
.mail-col { display: flex; flex-direction: column; gap: 16px; min-width: 0; }
.mail-col--preview { position: sticky; top: 90px; }
.mail-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 1px 3px rgba(24, 28, 50, .06);
}
.mail-card__title {
  display: flex; align-items: center; gap: 8px;
  margin: 0 0 14px; font-size: 15px; font-weight: 700; color: #181c32;
}
.mail-card__title i { color: #1b84ff; }
.mail-field { display: flex; flex-direction: column; gap: 6px; margin: 0 0 12px; width: 100%; }
.mail-field > span { font-size: 13px; font-weight: 600; color: #3f4254; }
.mail-field small { font-weight: 400; color: #a1a5b7; }
.mail-field input, .mail-field textarea, .mail-pick input, .mail-test input {
  width: 100%; padding: 9px 12px; border: 1px solid #e4e6ef; border-radius: 8px;
  background: #fff; font-size: 14px; color: #181c32; outline: none;
}
.mail-field textarea { resize: vertical; min-height: 180px; line-height: 1.5; }
.mail-field input:focus, .mail-field textarea:focus, .mail-pick input:focus, .mail-test input:focus { border-color: #1b84ff; }
.mail-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }

/* Người nhận */
.mail-targets { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
.mail-target {
  display: flex; gap: 10px; align-items: flex-start; margin: 0; cursor: pointer;
  padding: 12px; border: 1px solid #e4e6ef; border-radius: 10px; background: #fafbfc;
  transition: border-color .15s, background .15s;
}
.mail-target input { display: none; }
.mail-target i { font-size: 18px; color: #7e8299; margin-top: 1px; }
.mail-target b { display: block; font-size: 13px; color: #181c32; }
.mail-target small { font-size: 12px; color: #a1a5b7; }
.mail-target.is-active { border-color: #1b84ff; background: #eef6ff; }
.mail-target.is-active i { color: #1b84ff; }
.mail-states { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 14px; }
.mail-state {
  display: inline-flex; align-items: center; gap: 6px; margin: 0; cursor: pointer;
  padding: 6px 12px; border: 1px solid #e4e6ef; border-radius: 16px; font-size: 13px; color: #5e6278;
}
.mail-state.is-active { border-color: #1b84ff; background: #eef6ff; color: #1b5fae; font-weight: 600; }
.mail-pick { margin-top: 14px; display: flex; flex-direction: column; gap: 10px; }
.mail-pick__search { position: relative; display: flex; align-items: center; gap: 8px; }
.mail-pick__search > i { position: absolute; left: 12px; color: #a1a5b7; }
.mail-pick__search input { padding-left: 34px; }
.mail-pick__results { border: 1px solid #eff2f5; border-radius: 10px; overflow: hidden; }
.mail-pick__result {
  display: flex; align-items: center; gap: 10px; width: 100%; padding: 8px 12px;
  border: 0; border-bottom: 1px solid #f5f6f8; background: #fff; font-size: 13px;
}
.mail-pick__result:last-child { border-bottom: 0; }
.mail-pick__result:hover:not(:disabled) { background: #f6f9ff; }
.mail-pick__result:disabled { opacity: .6; }
.mail-pick__result img { width: 28px; height: 28px; border-radius: 50%; object-fit: cover; background: #f1f1f4; }
.mail-pick__result small { max-width: 180px; }
.mail-pick__paste { display: flex; gap: 8px; }
.mail-chips { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; }
.mail-chip {
  display: inline-flex; align-items: center; gap: 4px; padding: 4px 6px 4px 10px;
  border-radius: 14px; background: #eef6ff; color: #1b5fae; font-size: 12px; font-weight: 600;
}
.mail-chip i { cursor: pointer; font-size: 14px; }

/* Hành động */
.mail-actions { display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }
.mail-test { display: flex; gap: 8px; flex: 1 1 320px; }
.mail-send { flex: 0 0 auto; }

/* Xem trước */
.mail-preview__head { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
.mail-stats { display: flex; flex-wrap: wrap; gap: 16px; font-size: 13px; color: #5e6278; margin-bottom: 10px; }
.mail-stats b { color: #181c32; font-size: 16px; }
.mail-error { padding: 8px 12px; border-radius: 8px; background: #fff1f0; color: #b42318; font-size: 13px; margin-bottom: 10px; }
.mail-subject { font-size: 13px; color: #181c32; padding: 8px 12px; background: #f7f8fa; border-radius: 8px 8px 0 0; border: 1px solid #eff2f5; border-bottom: 0; }
.mail-subject span { color: #a1a5b7; }
.mail-frame { width: 100%; height: 620px; border: 1px solid #eff2f5; border-radius: 0 0 8px 8px; background: #fafafa; }
.mail-empty {
  display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 60px 20px;
  color: #a1a5b7; border: 1px dashed #e4e6ef; border-radius: 10px;
}
.mail-empty i { font-size: 32px; }
.mail-sample { margin-top: 12px; font-size: 13px; }
.mail-sample summary { cursor: pointer; color: #1b84ff; font-weight: 600; }
.mail-sample__row { display: flex; justify-content: space-between; gap: 10px; padding: 6px 0; border-bottom: 1px solid #f5f6f8; }
.mail-sample__row small { color: #7e8299; }

@media (max-width: 1199.98px) {
  .mail-page { grid-template-columns: 1fr; }
  .mail-col--preview { position: static; }
}
@media (max-width: 767.98px) {
  .mail-targets, .mail-row { grid-template-columns: 1fr; }
  .mail-frame { height: 480px; }
}

/* Tabs */
.mail-tabs { display: flex; gap: 6px; margin-bottom: 16px; }
.mail-tabs button {
  display: inline-flex; align-items: center; gap: 6px; height: 38px; padding: 0 16px;
  border: 1px solid #e4e6ef; border-radius: 10px; background: #fff; color: #5e6278; font-weight: 600; font-size: 14px;
}
.mail-tabs button.is-active { background: #1b84ff; border-color: #1b84ff; color: #fff; }

/* Lịch sử */
.hist { display: flex; flex-direction: column; gap: 10px; padding-bottom: 24px; }
.hist__bar { display: flex; align-items: center; gap: 12px; font-size: 13px; }
.hist__live { display: inline-flex; align-items: center; gap: 6px; color: #e9a800; font-weight: 600; }
.hist__dot { width: 8px; height: 8px; border-radius: 50%; background: #e9a800; animation: hist-pulse 1.2s infinite; }
@keyframes hist-pulse { 50% { opacity: .3; } }
.hist-item {
  display: flex; gap: 20px; align-items: center; padding: 14px 18px; cursor: pointer;
  background: #fff; border-radius: 12px; box-shadow: 0 1px 3px rgba(24, 28, 50, .06);
  transition: box-shadow .15s, transform .15s;
}
.hist-item:hover { box-shadow: 0 6px 18px rgba(24, 28, 50, .1); transform: translateY(-1px); }
.hist-item__main { flex: 1 1 auto; min-width: 0; }
.hist-item__subject { font-size: 15px; font-weight: 700; color: #181c32; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.hist-item__meta { display: flex; flex-wrap: wrap; gap: 14px; margin-top: 4px; font-size: 12px; color: #7e8299; }
.hist-item__meta i { margin-right: 3px; }
.hist-item__stats { flex: 0 0 340px; display: flex; flex-direction: column; gap: 6px; align-items: flex-end; }
.hist-progress { display: flex; width: 100%; height: 8px; border-radius: 4px; overflow: hidden; background: #f1f1f4; }
.hist-progress span { height: 100%; transition: width .4s; }
.hist-progress .is-success { background: #17c653; }
.hist-progress .is-fail { background: #f8285a; }
.hist-progress .is-pending { background: #f6c000; }
.hist-nums { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 10px; font-size: 12px; }
.hist-tag { display: inline-block; padding: 1px 8px; margin-right: 6px; border-radius: 6px; font-size: 11px; font-weight: 700; vertical-align: 2px; }
.hist-tag--test { background: #f1f1f4; color: #7e8299; }
.hist-status { display: inline-block; padding: 2px 10px; border-radius: 10px; font-size: 12px; font-weight: 600; }
.hist-status--success { background: #e8fff3; color: #0f9d58; }
.hist-status--fail { background: #fff0f3; color: #d81a48; }
.hist-status--pending { background: #fff8dd; color: #b07d00; }
.hist__pager { display: flex; align-items: center; justify-content: center; gap: 12px; margin-top: 6px; font-size: 13px; }
.hist-detail__nums { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; margin-bottom: 14px; }
.hist-detail__nums > div { padding: 10px; border-radius: 10px; background: #f7f8fa; text-align: center; }
.hist-detail__nums b { display: block; font-size: 20px; }
.hist-detail__nums small { color: #7e8299; }
.hist-detail__info { display: grid; gap: 4px; margin-bottom: 14px; font-size: 13px; }
.hist-detail__info span { display: inline-block; width: 90px; color: #a1a5b7; }
.hist-recipients { max-height: 420px; overflow: auto; border: 1px solid #eff2f5; border-radius: 10px; }
.hist-recipients__row { display: flex; justify-content: space-between; align-items: center; padding: 8px 12px; border-bottom: 1px solid #f5f6f8; font-size: 13px; }
.hist-recipients__row:last-child { border-bottom: 0; }
@media (max-width: 991.98px) {
  .hist-item { flex-direction: column; align-items: stretch; }
  .hist-item__stats { flex-basis: auto; align-items: stretch; }
  .hist-nums { justify-content: flex-start; }
  .hist-detail__nums { grid-template-columns: repeat(3, 1fr); }
}
</style>
